<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div>
            <slot />
          </div>
        </div>
        <Footer />
        <b-row>
          <b-col md="8">
            <div class="d-flex justify-content-start">
              <h2 class="mt-5">{{$t('message.Test_questions')}}</h2>
            </div>
          </b-col>
          <b-col md="3">
            <div class="d-flex justify-content-end mt-5">
              <b-button
                  class="btn"
                  variant="outline-info"
                  size="md"
                  style="margin-top: 100px; margin-right: 1300px"
                  @click="handleAdd"
              >
                <i class='bx bxs-plus-square'
                >{{$t('message.Add')}}</i>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-card
            style="width: 90%; margin: 0 auto"
            class="mt-4">
          <b-table
              responsive
              striped
              hover
              :items="questions"
              :fields="fields">
            <template #cell(id)="data">
              <span class="text-md text-primary"> {{ (pagination.page - 1)*pagination.pageSize+(data.index + 1) }}</span>
            </template>
            <template #cell(photo)="{item}">
              <img :src="`${$backendHost}/${item.photo}`" width="100" alt="">
            </template>
            <template #cell(action)="data">
              <div class="d-flex">
                <b-button
                    style="width: 50px; height: 40px"
                    size="sm"
                    variant="warning"
                    @click="handleEdit(data.item.id)"
                ><i class='bx bx-pencil'></i>
                </b-button>
                <b-button
                    size="sm"
                    style="margin-left: 10px; width: 50px; height: 40px"
                    class="ml-1"
                    variant="danger"
                    @click="handleDelete(data.item.id)"
                ><i class='bx bx-trash'></i>
                </b-button>
              </div>
            </template>
          </b-table>
          <div class="w-100 d-flex justify-content-end mt-4">
            <b-pagination
                v-model="pagination.page"
                :total-rows="total"
                :per-page="pagination.pageSize"
                aria-controls="my-table"
                @input="fetchQuestions"
            ></b-pagination>
          </div>
        </b-card>
        <b-modal
            v-model="activeModal"
            hide-footer
            id="modal-center"
            centered
            :title="$t('message.Subject_name')">
          <QuestionModal
              :id="id"
              :activeModal="activeModal"
              @closeModal="modalClose"/>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {deleteQuestion, getQuestions} from "../../../../../../../api/test_questions";
import QuestionModal from "./QuestionModal";
import Swal from "sweetalert2";
import HorizontalTopbarInside from "../../../../../../../components/horizontal-topbar-inside";

export default {
  name: "TestQuestions",
  components: {
    HorizontalTopbarInside,
    QuestionModal,
    SideBar
  },
  data() {
    return {
      id: null,
      isMenuCondensed: false,
      activeModal: false,
      questions: [],
      answers:[],
      pagination:{
        page: 1,
        pageSize: 20,
      },
      total: 1,
      fields: [
        {
          key:'id',
          label: this.$t('message.Id')
        },
        {
          key:'photo',
          label: this.$t('message.Photo')
        },
        {
          key:'question',
          label: this.$t('message.Question')
        },
        // {
        //   key:'answers',
        //   label: 'answers'
        // },
        // {
        //   key: 'test_id',
        //   label:this.$t('test_id')
        // },
        {
          key: 'action',
          label: this.$t("message.Action")
        },
      ],
    };
  },
  computed: {
    ...layoutComputed,
  },
  created ()  {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchQuestions()
  },
  methods: {
    fetchQuestions(){
      // eslint-disable-next-line no-console
      console.log(this.pagination);
      getQuestions({...this.$route.params, ...this.pagination}).then(response => {
        this.questions = response.data.data
        this.total = response.data.total;
      })
    },
    handleAdd() {
      this.id = null;
      this.activeModal = true;
    },
    handleEdit(id) {
      this.id = id;
      this.activeModal = true;
    },
    modalClose(){
      this.activeModal = false
      this.fetchQuestions()
    },
    closeModal(){
      this.activeModal = false
    },
    handleDelete(id) {
      if (id) {
        Swal.fire({
          title: this.$t("message.Are_you_sure"),
          text: this.$t("message.Not_revert"),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('message.Delete_it'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            // eslint-disable-next-line no-unused-vars
            deleteQuestion({ id }).then(res => {
              Swal.fire({
                icon: 'success',
                position: 'center',
                title: this.$t('message.Deleted'),
                text: this.$t('message.File_deleted'),
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.fetchQuestions()
            })
          } else if (result.dismiss === 'cancel') {
            Swal.fire({
              title: this.$t('message.Cancelled'),
              text: this.$t('message.File_safe'),
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}
.btn{
  width: 140px;
  height: 50px;
}
.bx{
  font-size: 19px;
}
</style>



